import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './componentes/Layout';
import { Cargando } from './componentes/UI';
import { ProveedorAuth, useAuth } from './contextos/AuthContext';
import { ProveedorAvisos } from './contextos/AvisosContext';
import { ProveedorTema } from './contextos/TemaContext';
import { Calendario } from './paginas/Calendario';
import { Cobranza } from './paginas/Cobranza';
import { Competencia } from './paginas/Competencia';
import { Costos } from './paginas/Costos';
import { Dashboard } from './paginas/Dashboard';
import { Login } from './paginas/Login';
import { NuevaOferta } from './paginas/NuevaOferta';
import { Organismos } from './paginas/Organismos';
import { Proyectos } from './paginas/Proyectos';
import { FichaProyecto } from './paginas/proyecto/FichaProyecto';
import { Empresa } from './paginas/Empresa';
import { Pipeline } from './paginas/Pipeline';
import { Motor } from './paginas/Motor';
import { Reporte } from './paginas/Reporte';

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      // Los datos del CRM cambian por acción del usuario, no solos: refrescar al
      // volver a la pestaña es ruido, y una ventana de frescura corta basta.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    },
  },
});

function Rutas() {
  const { usuario, cargando } = useAuth();

  if (cargando) return <Cargando texto="Verificando tu sesión…" />;
  if (!usuario) return <Login />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Navigate to="/" replace />} />
        <Route path="proyectos" element={<Proyectos />} />
        <Route path="proyectos/:id" element={<FichaProyecto />} />
        <Route path="costos" element={<Costos />} />
        <Route path="cobranza" element={<Cobranza />} />
        <Route path="empresa" element={<Empresa />} />
        <Route path="configuracion" element={<Navigate to="/empresa" replace />} />
        <Route path="pipeline" element={<Pipeline />} />
        <Route path="calendario" element={<Calendario />} />
        <Route path="organismos" element={<Organismos />} />
        <Route path="competencia" element={<Competencia />} />
        <Route path="motor" element={<Motor />} />
        <Route path="reporte" element={<Reporte />} />
        <Route path="licitaciones/nueva" element={<NuevaOferta />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <ProveedorTema>
      <QueryClientProvider client={cliente}>
        <ProveedorAvisos>
          <BrowserRouter>
            <ProveedorAuth>
              <Rutas />
            </ProveedorAuth>
          </BrowserRouter>
        </ProveedorAvisos>
      </QueryClientProvider>
    </ProveedorTema>
  );
}
